import React, { useState } from 'react';
import { requestUnlockApi } from '../../api/auth.api';

/** نمایش‌داده‌شده وقتی حساب مسدود شده؛ کاربر درخواست رفع مسدودیت برای مدیر می‌فرستد */
export default function UnlockRequestBox({ email }) {
  const [message, setMessage] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const send = async () => {
    setError('');
    setLoading(true);
    try {
      await requestUnlockApi(email, message || undefined);
      setSent(true);
    } catch (err) {
      setError(err?.response?.data?.message || 'ارسال درخواست ناموفق بود');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="rounded-2xl border border-emerald-400/30 bg-emerald-500/10 p-4 text-sm leading-7 text-emerald-200">
        ✅ درخواست شما برای مدیر سیستم ارسال شد. پس از بررسی و تأیید، می‌توانید دوباره وارد شوید.
      </div>
    );
  }

  return (
    <div className="space-y-3 rounded-2xl border border-amber-400/30 bg-amber-500/10 p-4">
      <p className="text-sm font-black text-amber-200">درخواست رفع مسدودیت</p>
      <p className="text-xs leading-6 text-amber-100/70">
        حساب «{email}» مسدود است. توضیح کوتاهی بنویسید تا مدیر سیستم بررسی و حساب را آزاد کند.
      </p>
      <textarea
        rows={3}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="مثلاً رمز را فراموش کرده بودم (اختیاری)"
        className="w-full rounded-xl border border-white/10 bg-white/5 p-3 text-sm text-white outline-none placeholder:text-white/30 focus:border-amber-300"
      />
      {error && <p className="text-xs font-bold text-red-300">{error}</p>}
      <button
        type="button"
        onClick={send}
        disabled={loading || !email}
        className="h-11 w-full rounded-full bg-amber-400 text-sm font-black text-slate-900 transition hover:bg-amber-300 disabled:opacity-50"
      >
        {loading ? 'در حال ارسال...' : 'ارسال درخواست به مدیر سیستم'}
      </button>
    </div>
  );
}
